import React, { ReactElement } from "react";

export interface ValueWithLabelAndUnit {
  name: string;
  value: string;
  unit?: string;
}

export default function AdditionalValueDisplay({
  values,
}: {
  values: ValueWithLabelAndUnit[];
}): ReactElement {
  return (
    <div
      className="d-flex"
      style={{
        gap: "10px",
        marginBottom: "15px",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {values.map((item, i) => (
        <div key={i} className="text-left" style={{ whiteSpace: "nowrap" }}>
          <div>{item.name}</div>
          <div>
            <b>{item.value}</b> {item.unit}
          </div>
        </div>
      ))}
    </div>
  );
}
